import React, { useEffect, useMemo, useState } from "react";
import { Row, Col } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm";
import SelectInput from "../../../custom/components/Select-Input/SelectInput";
import TextInput from "../../../custom/components/Text-Input/TextInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, basicFormData } from "./UserFile";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput";
import { validate } from "../../../custom/validations/Validate";
import { getRecords, saveRecords } from "../../../services/api.service";
import { toast } from "react-toastify";

const UserCreate = () => {
  
  const { id } = useParams();
  const schema = localStorage.getItem("schema")
  const navigate = useNavigate();

  const {
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    payload
  } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [formErrors, setFormErrors] = useState({});
  // role
  const [roleSelectOptions, setRoleSelectOptions] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [isPasswordShown, setIsPasswordShown] = useState(false);

  const [branchSelectOptions, setBranchSelectOptions] = useState([])
  const [selectedBranch, setSelectedBranch] = useState([])

  useEffect(() => {
    if (id) {
      setIsPasswordShown(true);
      getEditData();
    } else {
      getRoleData();
      getBranchData()
    }
  }, [id]);

  const getEditData = async () => {
    try {
      const payload = {
        modelName: initialPayload?.modelName,
        schema: schema,
        whereCondition: { id: id, is_active: true },
        "include": [
          {
            "model": "role_masters",
            "as": "role"
          },
          {
            "model": "branch_masters",
            "as": "branch"
          }
        ]
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        const { role, branch, ...rest } = data;
        // console.log(rest)
        setFormData({inputData:rest})
        getRoleData()
        getBranchData()
        setSelectedBranch({value:data.branch?.id, label:data.branch?.branch_name})
        setSelectedRole({value:data.role?.id, label:data.role?.role_name})
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const getRoleData = async () => {
    try {
      let payload = {
        modelName: "role_masters",
        // whereCondition: {
        //   is_active: true,
        // },
        schema:schema
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map(item => ({
        value: item.id,
        label: item.role_name
      }));
      setRoleSelectOptions(newArray)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getBranchData = async () => {
    try {
      let payload = {
        modelName: "branch_masters",
        schema:schema
      };

      const responseData = await getRecords(payload, "/getRecords");
      if (responseData.code===1) {
        const newArray = responseData.data?.map(item => ({
          value: item.id,
          label: item.branch_name
        }));
        setBranchSelectOptions(newArray)
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  

  const handleRoleSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      role_id: selectedValue,
    });

    setSelectedRole(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      role_id: fieldError?.role_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        role_id: selectedValue,
      },
    }));
  };

  const handleBranchSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      branch_id: selectedValue,
    });
    setSelectedBranch(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      branch_id: fieldError?.branch_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        branch_id: selectedValue,
      },
    }));
  };  

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormErrors((prevErrors) => {
      const fieldError = validate(validationType, { [name]: value });
      return {
        ...prevErrors,
        [name]: fieldError[name] || null,
      };
    });

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]:
          type === "checkbox"
            ? checked === true
              ? 1
              : 0
            : name === "alt_mobile_number" && value === ""
            ? null
            : value,
      },
    }));
  };

  const handleSubmit = async (e) => {

    let payload = {
      modelName: initialPayload?.modelName,
      schema:schema
    };

    try {
      e.preventDefault();
      setLoadingData(true);

      const userDetails = JSON.parse(localStorage.getItem("authUser"));

      const validationErrors = validate(validationType, formData.inputData);
      setFormErrors(validationErrors)
      if (JSON.stringify(validationErrors) !== "{}") return
      

      if (id) {
        //update 
        formData.inputData.updated_by = id ? userDetails?.id || "" : "";
        payload = { ...payload, id: id, inputData: formData?.inputData, relation: [] }

      } else {
        // create
        formData.inputData.created_by = userDetails?.id || "";
        formData.inputData.updated_by = userDetails?.id || "";
        payload = {...payload, inputData:formData?.inputData, relation:[]}

      }
     
      // console.log(payload)
      // return
      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      // Handle response and update on localStorage

      if (responseData && responseData.code === 1) {
        if (id && userDetails && userDetails.id === parseInt(id)) {
          const updatedUserDetails = {
            ...userDetails,
            first_name: formData.inputData.first_name,
            last_name: formData.inputData.last_name,
            email_id: formData.inputData.email_id,
            mobile_number: formData.inputData.mobile_number,
            role_id: formData.inputData.role_id,
            branch_id: formData.inputData.branch_id,
            role_name: selectedRole?.label || userDetails.role_name,
            role_masters: {
              ...(userDetails.role_masters || {}),
              id: formData.inputData.role_id,
              role_name: selectedRole?.label || userDetails.role_masters || {},
            },
          };
          localStorage.setItem(
            "authUser",
            JSON.stringify(updatedUserDetails)
          );

          // Dispatch events to notify other components
          const event = new Event("userDetailsUpdated");
          window.dispatchEvent(event);
        }
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };


  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        <Col md="6" className="mt-3">
          <SelectInput
            label="role"
            options={roleSelectOptions}
            value={selectedRole}
            onSelect={handleRoleSelect}
            placeholder="Select Role"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.role_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="branch"
            options={branchSelectOptions}
            value={selectedBranch}
            onSelect={handleBranchSelect}
            placeholder="Select Branch"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.branch_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="First Name"
            name="first_name"
            value={formData?.inputData?.first_name}
            onChange={onInputChange}
            placeholder="First Name"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.first_name}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Last Name"
            name="last_name"
            value={formData?.inputData?.last_name}
            onChange={onInputChange}
            placeholder="Last Name"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.last_name}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Username"
            name="username"
            value={formData?.inputData?.username}
            onChange={onInputChange}
            placeholder="Username"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.username}
          />
        </Col>
        {selectedRole?.label === "Technician" && (<Col md="6" className="mt-3">
          <TextInput
            label="Skill"
            name="skill"
            value={formData?.inputData?.skill}
            onChange={onInputChange}
            placeholder="Skill"
            inputClassName="form-control"
            labelClassName="form-label"
            customError={formErrors?.skill}
          />
        </Col>)}
        
        <Col md="6" className="mt-3">
          <TextInput
            label="Email"
            name="email_id"
            value={formData?.inputData?.email_id}
            onChange={onInputChange}
            placeholder="Email"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.email_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Password"
            name="password"
            value={formData?.inputData?.password}
            onChange={onInputChange}
            placeholder="Password"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.password}
            type={isPasswordShown ? "password" : "text"}
            disabled={id ? true : false}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Mobile Number"
            name="mobile_number"
            value={formData?.inputData?.mobile_number}
            onChange={onInputChange}
            placeholder="Mobile Number"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.mobile_number}
          />
        </Col>
      </Row>

      {/* Add documents */}

      <Row className="mt-4">
        <Col lg="12">
          <CheckboxInput
            name="is_active"
            label="Is Active"
            value={formData?.inputData?.is_active}
            checked={formData?.inputData?.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
          />
        </Col>
      </Row>
    </CustomForm>
  );
};

export default UserCreate;
